import React from 'react'

import ServiceArea from '../components/Services/ServiceArea'
import Accessability from '../components/Services/Accessability'
import Consultation from '../components/Services/Consultation'
import Design from '../components/Services/Design'
import FrontEndDev from '../components/Services/FrontEndDev'
import BackEndDev from '../components/Services/BackEndDev'
import FullStack from '../components/Services/FullStack'
import { BackTop } from 'antd'

const Services = () => {
    return (
        <div>
            <h1>Services</h1>
            <ServiceArea
                alignment="Left"
                className="consultation"
                component={<Consultation />}
            />
            <ServiceArea
                alignment="Center"
                className="audit"
                component={<Accessability />}
            />
            <ServiceArea
                alignment="Left"
                className="design"
                component={<Design />}
            />
            <ServiceArea
                alignment="Center"
                className="frontEnd"
                component={<FrontEndDev />}
            />
            <ServiceArea
                alignment="Center"
                className="backEnd"
                component={<BackEndDev />}
            />
            <ServiceArea
                alignment="Center"
                className="fullStack"
                component={<FullStack />}
            />
        </div>
    )
}

export default Services
